export const Flags = {
    OnaAIEnabled: "onaAIEnabled",
    InsightsEnabled: "isInsightsEnabled",
};
